import {Component} from '@angular/core';
import {MembershipService} from '../membership/membership.service';
import {ToastController} from 'ionic-angular';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {BackendModule} from '../../../../modules/backend.module';
import {SessionService} from '../../../../services/session';
import {LocationsService} from '../../../../services/locations';

// pwa/app difference: App uses Ionic native social sharing and clipboard

@Component({
  selector: 'page-referral',
  templateUrl: 'referral.html'
})
export class ReferralPage {
  constructor(
    private membershipService: MembershipService,
    public toastCtrl: ToastController,
    public iab: InAppBrowser,
    public backendModule: BackendModule,
    public sessionService: SessionService,
    public locationsService: LocationsService,
  ) {
  }

  ionViewDidLoad() {
    if (!this.membershipService.referralTerms[1]) {
      this.backendModule.getAPI('subscriptions/referral_terms.json').subscribe(
        (response: any) => {
          this.membershipService.referralTerms = response.referral_terms;
        },
        err => {
          this.sessionService.reportError(
            'referralPage',
            'ionViewDidLoad()',
            err
          );
        }
      );
    }
  }

  copy() {
    window.navigator.clipboard
      .writeText(this.membershipService.referralCode)
      .catch(err => {
      })
      .then(() => {
        this.presentToast('Copied to clipboard');
      })
      .catch(err => {
        this.sessionService.reportError('referralPage', 'copy()', err);
        this.presentToast('Could not copy to clipboard');
      });
  }

  share() {
    this.copy();
  }

  presentToast(text) {
    const toast = this.toastCtrl.create({
      message: text,
      duration: 3000
    });
    toast.present();
  }

  openBrowser(url) {
    this.iab.create(url, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/referral/referral.ts